var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect } from 'react';
import { useSignalRConnector } from './use-signal-r-connector';
export var useCreateSignalREffect = function (url, baseUrl) {
    var hubConnection = useSignalRConnector(url, baseUrl);
    var useSignalREffect = function (events, callback, deps) {
        useEffect(function () {
            if (hubConnection) {
                var _events_1;
                var _callback_1 = function (args) {
                    try {
                        callback(args);
                    }
                    catch (_) {
                        window.location.reload();
                    }
                };
                if (!Array.isArray(events)) {
                    _events_1 = [events];
                }
                else {
                    _events_1 = events;
                }
                _events_1.forEach(function (event) {
                    hubConnection.on(event, _callback_1);
                });
                return function () {
                    _events_1.forEach(function (event) {
                        hubConnection.off(event, _callback_1);
                    });
                };
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, __spreadArray(__spreadArray([], deps, true), [hubConnection], false));
    };
    return { useSignalREffect: useSignalREffect, hubConnection: hubConnection };
};
